import { ConsentDetails, UAE_DATA_CLUSTERS, VRPPayment } from './uaeStandards'

// TPP Logos
const VELOX_LOGO =
  'https://cdn.magicpatterns.com/uploads/6ixnVN3mm3sFs3kb5m4Wow/apple-touch-icon.png'
const PAY10_LOGO =
  'https://cdn.magicpatterns.com/uploads/67sckJDXT5n2QamZBeKfeP/Pay10-logo-Registered-Red-PNG-3.png'
const LEAN_LOGO =
  'https://cdn.magicpatterns.com/uploads/qNZ9cVv63kDAXJRFX144FE/lean_logo.jpg'

// Bank Logos
const ENBD_LOGO =
  'https://uploadthingy.s3.us-west-1.amazonaws.com/91j45KU69fJgTXQvxBLPwL/ENBD.jpg'
const FAB_LOGO =
  'https://uploadthingy.s3.us-west-1.amazonaws.com/ii5ZfgQSfFd3JdiuLGJR9e/First-Abu-Dhabi-Bank.svg'
const ADIB_LOGO =
  'https://uploadthingy.s3.us-west-1.amazonaws.com/tNEFVG5j2DGJtEABNU4nN9/ADIB.jpg'
const MASHREQ_LOGO =
  'https://uploadthingy.s3.us-west-1.amazonaws.com/jubwaaX5WAee9nTRWWTwB8/Mashreg.jpg'
const ADCB_LOGO =
  'https://cdn.magicpatterns.com/uploads/wpkTMSY3dU4JPGR41Jm2TG/ADCB_icon.svg'

// Merchant Logos - Real logos
const DEWA_LOGO =
  'https://cdn.magicpatterns.com/uploads/wbj2HpHu55bQSoaA3wgQAx/dewa_logo.jpg'
const ETISALAT_LOGO =
  'https://cdn.magicpatterns.com/uploads/vhDqwHd25kiP5Bez6wec3o/Eand_Logo_EN.svg'
const DU_LOGO =
  'https://cdn.magicpatterns.com/uploads/7Hj1r95nXads1skE6Dv7Lm/du-logo-png_seeklogo-490380.png'

// Helper: Generate date X days ago
function daysAgo(days: number): string {
  const date = new Date()
  date.setDate(date.getDate() - days)
  return date.toLocaleDateString('en-GB')
}

// Helper: Generate date X days from now
function daysFromNow(days: number): string {
  const date = new Date()
  date.setDate(date.getDate() + days)
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  })
}

// Helper: ISO timestamp X days ago
function isoTimestampDaysAgo(days: number): string {
  const date = new Date()
  date.setDate(date.getDate() - days)
  return date.toISOString()
}

// ACTIVE CONSENTS (Authorized)
export const MOCK_ACTIVE_CONSENTS: ConsentDetails[] = [
  {
    id: '1',
    consentId: '1234567890123456',
    type: 'DataSharing',
    state: 'Authorized',
    tppName: 'VeloX',
    tppTradingName: 'VeloX',
    tppLegalName: 'VeloX Financial Services LLC',
    tppLogo: VELOX_LOGO,
    bankName: 'Abu Dhabi Commercial Bank',
    bankLogo: ADCB_LOGO,
    accountType: 'Current Account',
    accountNumber: '4627033234562456',
    accountLastFour: '2456',
    connectedDate: daysAgo(45),
    authorizedDate: daysAgo(45),
    expiryDate: daysFromNow(135), // 6 months from connection
    lastAccessDate: isoTimestampDaysAgo(2),
    durationMonths: 6,
    dataClusters: UAE_DATA_CLUSTERS.slice(0, 5),
    selectedAccounts: [
      {
        id: '1',
        name: 'Current Account',
        accountNumber: '4627033234562456',
        accountType: 'Current Account',
      },
    ],
    createdBy: 'User',
    lastModified: isoTimestampDaysAgo(2),
    version: 1,
  },
  {
    id: '2',
    consentId: '9876543210987654',
    type: 'ServiceInitiation',
    state: 'Authorized',
    tppName: 'Pay10',
    tppTradingName: 'Pay10',
    tppLegalName: 'Pay10 Technologies LLC',
    tppLogo: PAY10_LOGO,
    bankName: 'Abu Dhabi Commercial Bank',
    bankLogo: ADCB_LOGO,
    accountType: 'Savings Account',
    accountNumber: '7890123456789012',
    accountLastFour: '9012',
    connectedDate: daysAgo(120),
    authorizedDate: daysAgo(120),
    expiryDate: daysFromNow(240), // 12 months from connection
    lastAccessDate: isoTimestampDaysAgo(5),
    durationMonths: 12,
    dataClusters: UAE_DATA_CLUSTERS.slice(0, 3),
    selectedAccounts: [
      {
        id: '2',
        name: 'Savings Account',
        accountNumber: '7890123456789012',
        accountType: 'Savings',
      },
    ],
    transactionLog: [
      {
        id: 'tx1',
        date: daysAgo(5),
        amount: 500,
        currency: 'AED',
        status: 'Completed',
        description: 'Transfer to Savings',
        recipient: 'Personal Savings',
      },
      {
        id: 'tx2',
        date: daysAgo(12),
        amount: 1200,
        currency: 'AED',
        status: 'Completed',
        description: 'Bill Payment',
        recipient: 'DEWA',
      },
      {
        id: 'tx3',
        date: daysAgo(18),
        amount: 350,
        currency: 'AED',
        status: 'Completed',
        description: 'Online Purchase',
        recipient: 'Noon.com',
      },
    ],
    createdBy: 'User',
    lastModified: isoTimestampDaysAgo(5),
    version: 1,
  },
  {
    id: '3',
    consentId: '5555666677778888',
    type: 'DataSharing',
    state: 'Paused',
    tppName: 'Pay10',
    tppTradingName: 'Pay10',
    tppLegalName: 'Pay10 Technologies LLC',
    tppLogo: PAY10_LOGO,
    bankName: 'Mashreq Bank',
    bankLogo: MASHREQ_LOGO,
    accountType: 'Credit Card',
    accountNumber: '1111222233334444',
    accountLastFour: '4444',
    connectedDate: daysAgo(200),
    authorizedDate: daysAgo(200),
    expiryDate: daysFromNow(160), // 12 months from connection
    lastAccessDate: isoTimestampDaysAgo(30),
    durationMonths: 12,
    dataClusters: UAE_DATA_CLUSTERS.slice(0, 4),
    selectedAccounts: [
      {
        id: '3',
        name: 'Credit Card',
        accountNumber: '1111222233334444',
        accountType: 'Credit',
      },
    ],
    createdBy: 'User',
    lastModified: isoTimestampDaysAgo(30),
    version: 1,
  },
  {
    id: '9',
    consentId: '2222111100009999',
    type: 'DataSharing',
    state: 'Authorized',
    tppName: 'VeloX',
    tppTradingName: 'VeloX',
    tppLegalName: 'VeloX Financial Services LLC',
    tppLogo: VELOX_LOGO,
    bankName: 'ADIB',
    bankLogo: ADIB_LOGO,
    accountType: 'Savings Account',
    accountNumber: '6666555544443333',
    accountLastFour: '3333',
    connectedDate: daysAgo(90),
    authorizedDate: daysAgo(90),
    expiryDate: daysFromNow(90), // 6 months from connection
    lastAccessDate: isoTimestampDaysAgo(7),
    durationMonths: 6,
    dataClusters: UAE_DATA_CLUSTERS.slice(0, 4),
    selectedAccounts: [
      {
        id: '9',
        name: 'Savings Account',
        accountNumber: '6666555544443333',
        accountType: 'Savings',
      },
    ],
    createdBy: 'User',
    lastModified: isoTimestampDaysAgo(7),
    version: 1,
  },
  // VRP CONSENT - DEWA Bill Payment
  {
    id: '10',
    consentId: 'VRP1234567890',
    type: 'ServiceInitiation',
    state: 'Authorized',
    tppName: 'VeloX',
    tppTradingName: 'VeloX',
    tppLegalName: 'VeloX Financial Services LLC',
    tppLogo: VELOX_LOGO,
    merchantName: 'DEWA',
    bankName: 'Abu Dhabi Commercial Bank',
    bankLogo: ADCB_LOGO,
    accountType: 'Current Account',
    accountNumber: '4627033234562456',
    accountLastFour: '2456',
    connectedDate: daysAgo(60),
    authorizedDate: daysAgo(60),
    expiryDate: daysFromNow(305), // 12 months from connection
    lastAccessDate: isoTimestampDaysAgo(30),
    durationMonths: 12,
    dataClusters: [],
    selectedAccounts: [
      {
        id: '1',
        name: 'Current Account',
        accountNumber: '4627033234562456',
        accountType: 'Current Account',
      },
    ],
    vrpDetails: {
      frequency: 'monthly',
      maxAmountPerPayment: 1000,
      totalPaymentsAllowed: 12,
      paymentsCompleted: 2,
      firstPaymentDate: daysAgo(60),
      nextPaymentDate: daysFromNow(3),
      reference: 'DEWA-123456789',
      paymentPurpose: 'utility-bill',
      merchantName: 'DEWA',
      merchantLogo: DEWA_LOGO,
      allowBalanceCheck: true,
    },
    paymentHistory: [
      {
        id: 'vrp-pay-1',
        date: daysAgo(60),
        amount: 450,
        currency: 'AED',
        status: 'completed',
        reference: 'DEWA-123456789',
        description: 'DEWA Electricity Bill - December',
        recipient: 'Dubai Electricity & Water Authority',
      },
      {
        id: 'vrp-pay-2',
        date: daysAgo(30),
        amount: 485,
        currency: 'AED',
        status: 'completed',
        reference: 'DEWA-123456789',
        description: 'DEWA Electricity Bill - January',
        recipient: 'Dubai Electricity & Water Authority',
      },
      {
        id: 'vrp-pay-3',
        date: daysFromNow(3),
        amount: 450,
        currency: 'AED',
        status: 'scheduled',
        reference: 'DEWA-123456789',
        description: 'DEWA Electricity Bill - February',
        recipient: 'Dubai Electricity & Water Authority',
      },
    ],
    createdBy: 'User',
    lastModified: isoTimestampDaysAgo(30),
    version: 1,
  },
  // VRP CONSENT - Etisalat Bill Payment
  {
    id: '11',
    consentId: 'VRP9876543210',
    type: 'ServiceInitiation',
    state: 'Authorized',
    tppName: 'VeloX',
    tppTradingName: 'VeloX',
    tppLegalName: 'VeloX Financial Services LLC',
    tppLogo: VELOX_LOGO,
    merchantName: 'Etisalat',
    bankName: 'Abu Dhabi Commercial Bank',
    bankLogo: ADCB_LOGO,
    accountType: 'Current Account',
    accountNumber: '4627033234562456',
    accountLastFour: '2456',
    connectedDate: daysAgo(90),
    authorizedDate: daysAgo(90),
    expiryDate: daysFromNow(275), // 12 months from connection
    lastAccessDate: isoTimestampDaysAgo(30),
    durationMonths: 12,
    dataClusters: [],
    selectedAccounts: [
      {
        id: '1',
        name: 'Current Account',
        accountNumber: '4627033234562456',
        accountType: 'Current Account',
      },
    ],
    vrpDetails: {
      frequency: 'monthly',
      maxAmountPerPayment: 500,
      totalPaymentsAllowed: 12,
      paymentsCompleted: 3,
      firstPaymentDate: daysAgo(90),
      nextPaymentDate: daysFromNow(0),
      reference: 'ETISALAT-987654321',
      paymentPurpose: 'utility-bill',
      merchantName: 'Etisalat',
      merchantLogo: ETISALAT_LOGO,
      allowBalanceCheck: true,
    },
    paymentHistory: [
      {
        id: 'vrp-pay-4',
        date: daysAgo(90),
        amount: 299,
        currency: 'AED',
        status: 'completed',
        reference: 'ETISALAT-987654321',
        description: 'Etisalat Mobile Bill - November',
        recipient: 'Etisalat UAE',
      },
      {
        id: 'vrp-pay-5',
        date: daysAgo(60),
        amount: 299,
        currency: 'AED',
        status: 'completed',
        reference: 'ETISALAT-987654321',
        description: 'Etisalat Mobile Bill - December',
        recipient: 'Etisalat UAE',
      },
      {
        id: 'vrp-pay-6',
        date: daysAgo(30),
        amount: 299,
        currency: 'AED',
        status: 'completed',
        reference: 'ETISALAT-987654321',
        description: 'Etisalat Mobile Bill - January',
        recipient: 'Etisalat UAE',
      },
      {
        id: 'vrp-pay-7',
        date: daysFromNow(0),
        amount: 299,
        currency: 'AED',
        status: 'scheduled',
        reference: 'ETISALAT-987654321',
        description: 'Etisalat Mobile Bill - February',
        recipient: 'Etisalat UAE',
      },
    ],
    createdBy: 'User',
    lastModified: isoTimestampDaysAgo(30),
    version: 1,
  },
]

// PENDING CONSENTS (Awaiting Authorization)
export const MOCK_PENDING_CONSENTS: ConsentDetails[] = [
  {
    id: '4',
    consentId: '2222333344445555',
    type: 'DataSharing',
    state: 'Awaiting',
    tppName: 'VeloX',
    tppTradingName: 'VeloX',
    tppLegalName: 'VeloX Financial Services LLC',
    tppLogo: VELOX_LOGO,
    bankName: 'Abu Dhabi Commercial Bank',
    bankLogo: ADCB_LOGO,
    accountType: 'Savings Account',
    accountNumber: '9999888877776666',
    accountLastFour: '6666',
    connectedDate: daysAgo(1),
    expiryDate: daysFromNow(179), // 6 months from request
    durationMonths: 6,
    dataClusters: UAE_DATA_CLUSTERS.slice(0, 5),
    selectedAccounts: [
      {
        id: '4',
        name: 'Savings Account',
        accountNumber: '9999888877776666',
        accountType: 'Savings',
      },
    ],
    createdBy: 'TPP',
    lastModified: isoTimestampDaysAgo(1),
    version: 1,
  },
  {
    id: '5',
    consentId: '6666777788889999',
    type: 'ServiceInitiation',
    state: 'Awaiting',
    tppName: 'Lean Technologies',
    tppTradingName: 'Lean',
    tppLegalName: 'Lean Technologies FZ-LLC',
    tppLogo: LEAN_LOGO,
    merchantName: 'Careem',
    bankName: 'Abu Dhabi Commercial Bank',
    bankLogo: ADCB_LOGO,
    accountType: 'Current Account',
    accountNumber: '3333444455556666',
    accountLastFour: '6666',
    connectedDate: daysAgo(0),
    expiryDate: daysFromNow(90), // 3 months from request
    durationMonths: 3,
    dataClusters: UAE_DATA_CLUSTERS.slice(0, 3),
    selectedAccounts: [
      {
        id: '5',
        name: 'Current Account',
        accountNumber: '3333444455556666',
        accountType: 'Current Account',
      },
    ],
    createdBy: 'TPP',
    lastModified: new Date().toISOString(),
    version: 1,
  },
]

// HISTORY CONSENTS (Canceled, Expired, Rejected)
export const MOCK_HISTORY_CONSENTS: ConsentDetails[] = [
  {
    id: '6',
    consentId: '7777888899990000',
    type: 'DataSharing',
    state: 'Canceled',
    tppName: 'VeloX',
    tppTradingName: 'VeloX',
    tppLegalName: 'VeloX Financial Services LLC',
    tppLogo: VELOX_LOGO,
    bankName: 'Abu Dhabi Commercial Bank',
    bankLogo: ADCB_LOGO,
    accountType: 'Current Account',
    accountNumber: '1234567890123456',
    accountLastFour: '3456',
    connectedDate: daysAgo(400),
    authorizedDate: daysAgo(400),
    expiryDate: daysAgo(40), // Expired 40 days ago
    canceledDate: daysAgo(60),
    lastAccessDate: isoTimestampDaysAgo(65),
    durationMonths: 12,
    dataClusters: UAE_DATA_CLUSTERS.slice(0, 5),
    selectedAccounts: [
      {
        id: '6',
        name: 'Current Account',
        accountNumber: '1234567890123456',
        accountType: 'Current Account',
      },
    ],
    createdBy: 'User',
    lastModified: isoTimestampDaysAgo(60),
    version: 1,
  },
  {
    id: '7',
    consentId: '1111000099998888',
    type: 'DataSharing',
    state: 'Expired',
    tppName: 'Pay10',
    tppTradingName: 'Pay10',
    tppLegalName: 'Pay10 Technologies LLC',
    tppLogo: PAY10_LOGO,
    bankName: 'ADIB',
    bankLogo: ADIB_LOGO,
    accountType: 'Savings Account',
    accountNumber: '5555444433332222',
    accountLastFour: '2222',
    connectedDate: daysAgo(550),
    authorizedDate: daysAgo(550),
    expiryDate: daysAgo(10), // Expired 10 days ago
    lastAccessDate: isoTimestampDaysAgo(15),
    durationMonths: 18,
    dataClusters: UAE_DATA_CLUSTERS.slice(0, 4),
    selectedAccounts: [
      {
        id: '7',
        name: 'Savings Account',
        accountNumber: '5555444433332222',
        accountType: 'Savings',
      },
    ],
    createdBy: 'User',
    lastModified: isoTimestampDaysAgo(10),
    version: 1,
  },
  {
    id: '8',
    consentId: '4444333322221111',
    type: 'ServiceInitiation',
    state: 'Rejected',
    tppName: 'Pay10',
    tppTradingName: 'Pay10',
    tppLegalName: 'Pay10 Technologies LLC',
    tppLogo: PAY10_LOGO,
    merchantName: 'Noon.com',
    bankName: 'Abu Dhabi Commercial Bank',
    bankLogo: ADCB_LOGO,
    accountType: 'Current Account',
    accountNumber: '8888777766665555',
    accountLastFour: '5555',
    connectedDate: daysAgo(7),
    expiryDate: daysFromNow(83), // Would have been 3 months
    durationMonths: 3,
    dataClusters: UAE_DATA_CLUSTERS.slice(0, 2),
    selectedAccounts: [
      {
        id: '8',
        name: 'Current Account',
        accountNumber: '8888777766665555',
        accountType: 'Current Account',
      },
    ],
    createdBy: 'TPP',
    lastModified: isoTimestampDaysAgo(7),
    version: 1,
  },
]

// Mock upcoming bills (for dashboard display)
export interface UpcomingBill {
  id: string
  merchantName: string
  merchantLogo?: string
  amount: number
  currency: string
  dueDate: string
  daysUntilDue: number
  accountNumber: string
  reference: string
  category: 'utility' | 'telecom' | 'subscription' | 'insurance' | 'other'
  hasVRP: boolean
  vrpConsentId?: string
}

export const MOCK_UPCOMING_BILLS: UpcomingBill[] = [
  {
    id: 'bill-1',
    merchantName: 'DEWA',
    merchantLogo: DEWA_LOGO,
    amount: 450,
    currency: 'AED',
    dueDate: daysFromNow(3),
    daysUntilDue: 3,
    accountNumber: 'DEWA-123456789',
    reference: 'DEWA-123456789',
    category: 'utility',
    hasVRP: true,
    vrpConsentId: 'VRP1234567890',
  },
  {
    id: 'bill-2',
    merchantName: 'Etisalat',
    merchantLogo: ETISALAT_LOGO,
    amount: 299,
    currency: 'AED',
    dueDate: daysFromNow(0),
    daysUntilDue: 0,
    accountNumber: 'ETISALAT-987654321',
    reference: 'ETISALAT-987654321',
    category: 'telecom',
    hasVRP: true,
    vrpConsentId: 'VRP9876543210',
  },
  {
    id: 'bill-3',
    merchantName: 'du',
    merchantLogo: DU_LOGO,
    amount: 199,
    currency: 'AED',
    dueDate: daysFromNow(7),
    daysUntilDue: 7,
    accountNumber: 'DU-555666777',
    reference: 'DU-555666777',
    category: 'telecom',
    hasVRP: false,
  },
]

// Export all mock data
export const MOCK_DATA = {
  active: MOCK_ACTIVE_CONSENTS,
  pending: MOCK_PENDING_CONSENTS,
  history: MOCK_HISTORY_CONSENTS,
  upcomingBills: MOCK_UPCOMING_BILLS,
}
